export enum TrackingLink {
    GOOGLE_PLAY_STORE = 'https://play.google.com/store/apps/details?id=com.bumble.app&referrer=af_tranid%3D0bakbqavCI2DO7eQrbbyqA%26pid%3Dgoogleplayhomepage',
    APP_STORE_IOS = 'https://apps.apple.com/us/app/bumble-dating-app-meet-date/id930441707?mt=8',
}
